"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = void 0;
var _constant = require("./constant");
var formatDate = function formatDate(locale, date) {
  var localeConfig = _constant.LOCALE_CONFIG;
  var localeDate = new Intl.DateTimeFormat(locale, localeConfig).format(date);
  return localeDate;
};
exports.formatDate = formatDate;